import { useEffect } from 'react';

import useUIStore, {
  SIDEBAR_FULL_WIDTH,
  SIDEBAR_SHRINKED_WIDTH,
} from '@/stores/pure/UIStore';
import useWorkspaceCacheStore from '@/stores/WorkspaceCacheStore';

const useSidebar = (status: boolean) => {
  const { sidebarHidden, setSidebarHidden } = useUIStore(
    ({ sidebarHidden, setSidebarHidden }) => ({
      sidebarHidden,
      setSidebarHidden,
    }),
  );
  useEffect(() => {
    setSidebarHidden(!status);
    return () => {
      setSidebarHidden(status);
    };
  }, [sidebarHidden, setSidebarHidden, status]);
};

const useSidebarWidth = () => {
  const sidebarHidden = useUIStore((state) => state.sidebarHidden);
  const sidebarShrinked = useWorkspaceCacheStore(
    (state) => state.sidebarShrinked,
  );

  return sidebarHidden
    ? 0
    : sidebarShrinked
      ? SIDEBAR_SHRINKED_WIDTH
      : SIDEBAR_FULL_WIDTH;
};

export { useSidebarWidth };

export default useSidebar;
